import { useMemo } from 'react';

import { accessValue } from '../../../core/utils/accessors/access-value.js';

/**
 * Label count appearances through all the SingleValue instances
 *
 * @param data -
 * @param labelAccessor -
 */
export function useLabelCount(
  data: (number | string | Record<string, unknown>)[],
  labelAccessor?: string,
) {
  return useMemo(
    () =>
      data.reduce<number>((total, record) => {
        if (typeof record === 'object') {
          if (labelAccessor) {
            const label = accessValue<string>(record, labelAccessor);

            if (label) {
              return total + 1;
            }
          }
        }

        return total;
      }, 0),
    [data, labelAccessor],
  );
}
